import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { news } from '../data/newsData'

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: []
})
export class NewsComponent {
  title = "";
  text = "";
  constructor(private route: ActivatedRoute) {

    let id = this.route.snapshot.paramMap.get('id') ?? "";
    let _news = news.find(m => m.id == id);
    if (_news) {
      this.title = _news.title;
      this.text = _news.text;
    }
  }
}
